<template>
  <aside class="aside-navigation">
    <ul class="aside-navigation__list">
      <li v-for="child in children" :key="child.key" class="aside-navigation__item">
        <button :class="['aside-navigation__action', {'aside-navigation__action--active': isActiveChild(child)}]" @click="$emit('click', child)">
          <oie-base-icon
            v-if="child.icon"
            :icon="child.icon"
            size="s"
            class="aside-navigation__icon"></oie-base-icon>
          {{ child.name }}
        </button>
      </li>
    </ul>
  </aside>
</template>

<script>
import _ from 'lodash'

export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    activeChild: {
      type: Object,
      default: null
    }
  },
  methods: {
    isActiveChild(child) { return _.isEqual(child, this.activeChild) }
  }
}
</script>

<style lang="scss">
.aside-navigation__list {
  @include reset-list
}

.aside-navigation__list>*:not(:last-child) {
  margin-bottom: measure(quarter);
}

.aside-navigation__action {
  @include reset-button;
  @include body;
  width: 100%;
  padding: measure(half);
  border: 1px solid color(blue-3);
  background-color: color(blue-5);
}

.aside-navigation__action:hover {
  background-color: color(blue-4);
}

.aside-navigation__action--active {
  border: 2px solid color(brand-blue-3);
  background-color: color(blue-4);
}

.aside-navigation__icon {
  margin-right: measure(quarter);
}

</style>
